var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["POST /admin/franRegion/createRegion"],
                  expression: "['POST /admin/franRegion/createRegion']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v("添加")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          ref: "table",
          attrs: {
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            border: "",
            fit: "",
            "highlight-current-row": "",
            "span-method": _vm.columnSpanMethod
          },
          on: { "cell-click": _vm.handleCellClick }
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "大区",
              prop: "region",
              width: "90"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "区总",
              prop: "regionManager",
              width: "90"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "区总邮箱",
              prop: "regionManagerMail",
              width: "150"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "省份", prop: "province" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "省份经理",
              prop: "provinceManager",
              width: "90"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "省经理邮箱",
              prop: "provinceManagerMail",
              width: "180"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "小区总",
              prop: "smallRegion",
              width: "90"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "小区总邮箱",
              prop: "smallRegionMail",
              width: "160"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "状态",
              prop: "deleted",
              width: "60"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.deleted == true
                      ? _c("span", [_vm._v("已停用")])
                      : _c("span", [_vm._v("正常")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "100",
              "class-name": "small-padding fixed-width",
              width: "110"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/franRegion/updateProvince"],
                            expression:
                              "['POST /admin/franRegion/updateProvince']"
                          }
                        ],
                        attrs: {
                          type: "text",
                          icon: "el-icon-check",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdateProvince(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/franRegion/deleteProvince"],
                            expression:
                              "['POST /admin/franRegion/deleteProvince']"
                          }
                        ],
                        staticStyle: { color: "red" },
                        attrs: {
                          type: "text",
                          size: "mini",
                          icon: "el-icon-close"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDeleteProvince(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "1150px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "60px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "大区", prop: "region" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.dataForm.id > 0,
                      placeholder: "请输入大区名称"
                    },
                    model: {
                      value: _vm.dataForm.region,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "region", $$v)
                      },
                      expression: "dataForm.region"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "大区总", prop: "regionManager" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入大区总" },
                    model: {
                      value: _vm.dataForm.regionManager,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "regionManager", $$v)
                      },
                      expression: "dataForm.regionManager"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "大区总邮箱", prop: "regionManagerMail" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入大区总邮箱（多个邮箱,隔开）" },
                    model: {
                      value: _vm.dataForm.regionManagerMail,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "regionManagerMail", $$v)
                      },
                      expression: "dataForm.regionManagerMail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "省份配置" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", "margin-right": "5px" },
                      attrs: {
                        type: "text",
                        size: "mini",
                        icon: "el-icon-plus"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleAddProvince()
                        }
                      }
                    },
                    [_vm._v("添加省份")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.dataForm.provinces,
                        border: "",
                        fit: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "省份",
                          prop: "province",
                          width: "300px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-cascader", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.sysProvinces,
                                    placeholder: "请选择省市区",
                                    props: {
                                      expandTrigger: "hover",
                                      value: "id",
                                      label: "name",
                                      multiple: true,
                                      rows: 20
                                    },
                                    clearable: "",
                                    "show-all-levels": true,
                                    size: "mini"
                                  },
                                  model: {
                                    value: scope.row.province,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "province", $$v)
                                    },
                                    expression: "scope.row.province"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "省经理",
                          prop: "provinceManager",
                          width: "120"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入省经理" },
                                  model: {
                                    value: scope.row.provinceManager,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "provinceManager",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.provinceManager"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "省经理邮箱",
                          prop: "provinceManagerMail"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入省经理邮箱" },
                                  model: {
                                    value: scope.row.provinceManagerMail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "provinceManagerMail",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.provinceManagerMail"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "小区总",
                          prop: "smallRegion",
                          width: "120"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入小区总" },
                                  model: {
                                    value: scope.row.smallRegion,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "smallRegion", $$v)
                                    },
                                    expression: "scope.row.smallRegion"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "小区总邮箱",
                          prop: "smallRegionMail"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入小区总" },
                                  model: {
                                    value: scope.row.smallRegionMail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "smallRegionMail",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.smallRegionMail"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "50px",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  staticStyle: {
                                    color: "red",
                                    "font-size": "18px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRemoveProvince(
                                        scope.$index
                                      )
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createData }
                    },
                    [_vm._v("保存")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateData }
                    },
                    [_vm._v("确定")]
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tooltip",
        { attrs: { placement: "top", content: "返回顶部" } },
        [_c("back-to-top", { attrs: { "visibility-height": 100 } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }